/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 - http://www.apache.org/licenses/LICENSE-2.0
 */
"use strict";
exports.ARROW_DOWN = 40;
exports.ARROW_LEFT = 37;
exports.ARROW_RIGHT = 39;
exports.ARROW_UP = 38;
exports.ENTER = 13;
exports.ESCAPE = 27;
exports.SPACE = 32;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb21tb24va2V5cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7O0FBRVUsa0JBQVUsR0FBRyxFQUFFLENBQUM7QUFDaEIsa0JBQVUsR0FBRyxFQUFFLENBQUM7QUFDaEIsbUJBQVcsR0FBRyxFQUFFLENBQUM7QUFDakIsZ0JBQVEsR0FBRyxFQUFFLENBQUM7QUFDZCxhQUFLLEdBQUcsRUFBRSxDQUFDO0FBQ1gsY0FBTSxHQUFHLEVBQUUsQ0FBQztBQUNaLGFBQUssR0FBRyxFQUFFLENBQUMiLCJmaWxlIjoiY29tbW9uL2tleXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKlxuICogQ29weXJpZ2h0IDIwMTUgUGFsYW50aXIgVGVjaG5vbG9naWVzLCBJbmMuIEFsbCByaWdodHMgcmVzZXJ2ZWQuXG4gKiBMaWNlbnNlZCB1bmRlciB0aGUgQXBhY2hlIExpY2Vuc2UsIFZlcnNpb24gMi4wIC0gaHR0cDovL3d3dy5hcGFjaGUub3JnL2xpY2Vuc2VzL0xJQ0VOU0UtMi4wXG4gKi9cblxuZXhwb3J0IGNvbnN0IEFSUk9XX0RPV04gPSA0MDtcbmV4cG9ydCBjb25zdCBBUlJPV19MRUZUID0gMzc7XG5leHBvcnQgY29uc3QgQVJST1dfUklHSFQgPSAzOTtcbmV4cG9ydCBjb25zdCBBUlJPV19VUCA9IDM4O1xuZXhwb3J0IGNvbnN0IEVOVEVSID0gMTM7XG5leHBvcnQgY29uc3QgRVNDQVBFID0gMjc7XG5leHBvcnQgY29uc3QgU1BBQ0UgPSAzMjtcbiJdLCJzb3VyY2VSb290IjoiL3NvdXJjZS8ifQ==



/*****************
 ** WEBPACK FOOTER
 ** ./~/@blueprintjs/core/dist/common/keys.js
 ** module id = 56
 ** module chunks = 0
 **/